<template>
  <div class="content">
    <p>
      广告审核<span class="tips"
        >USDT指导价： 1 USDT = {{ guidancePrice }} {{guidanceCoinType}}</span
      >
    </p>
    <div class="actions-bar">
      <el-input placeholder="请输入广告ID" clearable v-model="id">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-input placeholder="请输入userId" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>

      <el-select v-model="status" placeholder="请选择审核状态">
        <el-option label="全部" value=""></el-option>
        <el-option label="新建" value="1"></el-option>
        <el-option label="审核中" value="2"></el-option>
        <el-option label="审核通过" value="3"></el-option>
        <el-option label="下架" value="4"></el-option>
        <el-option label="审核不通过" value="5"></el-option>
        <el-option label="已完成" value="-1"></el-option>
      </el-select>
      <el-button type="primary" class="searchBtn" @click="handleSearch"
        >搜索</el-button
      >
    </div>
    <el-table :data="adList" style="width: 100%">
      <el-table-column prop="id" label="广告ID"> </el-table-column>
      <el-table-column prop="merchantId" label="商家ID"> </el-table-column>
      <el-table-column label="userId">
        <template slot-scope="scope">
          <a class="account-link" @click="getUserDetail(scope.row.userId)">{{
            scope.row.userId
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="alleged" label="支付方式">
        <template slot-scope="scope">
          <span v-if="scope.row.payMethods.includes(0)">银行卡 , </span>
          <span v-if="scope.row.payMethods.includes(1)">支付宝 ,</span>
          <span v-if="scope.row.payMethods.includes(2)">微信,</span>
          <span v-if="scope.row.payMethods.includes(3)">PayPal</span>
        </template>
      </el-table-column>

      <el-table-column prop="" label="限制下单量">
        <template slot-scope="scope">
          <span
            >{{ scope.row.singleLimitMin }}-{{
              scope.row.singleLimitMax
            }}{{ scope.row.currencyCoin }}</span
          >
        </template>
      </el-table-column>

      <el-table-column prop="coinType" label="定价类型及单价">
        <template slot-scope="scope">
          <span v-if="scope.row.priceType == '1'">固定单价</span>
          <span v-if="scope.row.priceType == '2'">指数价</span>
          <span v-if="scope.row.priceType == '3'">盘口价）</span>
        </template>
      </el-table-column>

      <el-table-column prop="currencyCoin" label="指数">
        <template slot-scope="scope">
          <span>{{ scope.row.priceParam }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="currencyCoin" label="数量">
        <template slot-scope="scope">
          <span>{{ scope.row.totalAmount }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="currencyCoin" label="法币币种">
        <template slot-scope="scope">
          <span
            >{{ scope.row.currencyCoinAmount
            }}{{ scope.row.currencyCoin }}</span
          >
        </template>
      </el-table-column>

      <el-table-column prop="" label="方向">
        <template slot-scope="scope">
          <span v-if="scope.row.direction == 'B'">购买</span>
          <span v-else>出售</span>
        </template>
      </el-table-column>

      <el-table-column prop="" label="状态" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">新建</span>
          <span v-else-if="scope.row.status == 2">审核中</span>
          <span v-else-if="scope.row.status == 3">审核通过</span>
          <span v-else-if="scope.row.status == 4">下架</span>
          <span v-else-if="scope.row.status == 5">审核不通过</span>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="170">
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row)"
            type="text"
            v-if="scope.row.status == 2"
            size="small"
            >审核</el-button
          >
          <el-button
            @click="soldOut(scope.row.id)"
            type="text"
            v-if="scope.row.status == 3"
            size="small"
            >强制下架</el-button
          >
          <el-button
            @click="handleClick(scope.row)"
            type="text"
            v-else
            disabled
            size="small"
            >审核</el-button
          >

          <el-button @click="soldOut(scope.row.id)" type="text" size="small"
            >强制下架</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next, total, jumper"
      @current-change="pageChange"
      @size-change="sizeChange"
      :current-page="page"
      :page-size="size"
      :total="adListTotal"
      prev-text="上一页"
      next-text="下一页"
    >
    </el-pagination>
    <el-dialog title="审核" :visible.sync="auditlVisible" width="40%" center>
      <!-- {{ auditForm }} -->
      审核ID:{{ auditForm.id }}
      <el-form
        :model="auditForm"
        status-icon
        ref="auditForm"
        label-width="100px"
        class="applicationForm"
      >
        <p class="fromCaptionTitle">审核理由</p>
        <el-form-item label="理由" prop="nickName">
          <el-input type="textarea" v-model="auditForm.description"></el-input>
        </el-form-item>
        <div class="fenGeXian"></div>

        <p class="fromCaptionTitle">基本信息</p>

        <el-form-item label="状态">
          <el-select v-model="auditForm.isPassed" placeholder="请选择审核状态">
            <el-option label="通过" value="true"></el-option>
            <el-option label="不通过（取消订单）" value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="auditlVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditPayeeBtn">确 定</el-button>
      </span>
    </el-dialog>

    <balance :show="showBalance" @close="showBalance = false"></balance>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import api from "../../api";
import balance from "../../../balance";
export default {
  name: "merchantRecordList",
  data() {
    return {
      page: 1,
      size: 11,
      userId: "",
      id: "",
      status: "2",
      // MerchantRecordList:{}
      auditlVisible: false,
      auditForm: {
        id: "",
        description: "",
        isPassed: "",
      },
      showBalance: false,
    };
  },
  computed: {
    ...mapState("otc", ["adListTotal", "adList", "guidancePrice", "guidanceCoinType"]),
  },
  components: { balance },
  methods: {
    ...mapActions("otc", ["advertising"]),
    ...mapActions("withdrawalAudit", ["getUserWallet"]),
    pageChange(e) {
      this.page = e;
      this.handleSearch();
    },
    sizeChange(e) {
      this.page = e;
      this.handleSearch();
    },

    //shousuo
    handleSearch() {
      let that = this;

      if (that.id || that.userId) {
        that.userId = "";
      }
      this.advertising({
        id: that.id,
        userId: that.userId,
        status: that.status,
        size: that.size,
        page: that.page,
      });
    },

    handleClick(row) {
      let that = this;
      this.auditlVisible = true;
      this.auditForm.id = row.id;
    },

    //强制下架
    soldOut(id) {
      let that = this;
      this.$prompt("您确定要强制下架该广告？请手动输入userId", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: "userId格式不正确",
        inputPlaceholder: "userId必填",
      })
        .then(({ value }) => {
          api
            .advertisingSoldOut({
              id: id,
              userId: value,
            })
            .then((res) => {
              if (!res.code) {
                that.$message({
                  message: res.msg,
                  type: "success",
                });
                that.handleSearch();
              } else {
                that.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },

    allege(row) {
      let that = this;
      let data = {
        id: row.id,
      };
      api.advertisingApprove(data).then((res) => {
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success",
          });
          that.auditlVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    auditPayeeBtn() {
      let that = this;

      this.auditForm.id = this.auditForm.id.toString();

      if (this.auditForm.isPassed == "true") {
        this.auditForm.description = "";
      } else {
        if (!this.auditForm.description) {
          const h = that.$createElement;
          that.$notify({
            title: "",
            message: h("i", { style: "color: teal" }, "请填写理由"),
            // duration: 0
          });
          return false;
        }
        this.auditForm.description = this.auditForm.description.toString();
      }

      let data = this.auditForm;

      api.advertisingApprove(data).then((res) => {
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success",
          });
          that.auditlVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    getUserDetail(uid) {
      this.getUserWallet({ userId: uid });
      this.showBalance = true;
    },
  },

  mounted() {
    this.handleSearch();
  },
};
</script>

<style lang="less" scoped>
.content {
  .tips {
    float: right;
    margin-right: 20%;
  }
  .fenGeXian {
    width: 98%;
    height: 1px;
    background: #eaf0f2;
    clear: both;
    overflow: hidden;
    margin: 10px auto;
  }
  .actions-bar {
    width: 80%;
    display: flex;
    margin-bottom: 30px;
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
    .searchBtn {
      margin-left: 15px;
    }
  }

  .setImgBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .imgBox {
      width: 46%;
      height: auto;
      border: 1px dashed #c8cdd1;
      padding: 12px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      span {
        font-size: 14px;
        font-weight: bold;
      }
      img {
        width: 80%;
        float: right;
      }
    }
  }
}
</style>
